// extracted by mini-css-extract-plugin
module.exports = {"failed-submission-tooltip":"_13fycv"};